import { css } from '@fable/theme'
import { ReaderSummary } from './reader_summary'
import { ReaderStatCards } from './reader_stat_cards'
import { FlexBox } from '@fable/components'
import { useReaderSummary } from '../../lib/ctx/reader_summary'
import { useStats } from '../../lib/ctx/stats'
import { useStatsPermission } from '../../lib/hooks'
import { ReaderSummaryScreenshotButton } from './share_reader_summary'
import { useReadingGoals } from '../../lib/ctx/reading_goals'
import { ReadingGoals } from '../reading_goals'
import { MomBooks } from '../charts'
import { StatsPlusUpsell } from '../upsell'
import { GoalHabits } from '../charts/advanced_charts'
import { useStatsTheme } from '../../theme/ctx'

export const StatsProfileHero = () => {
  const isSelfView = useStats((s) => s.isSelfView)
  const [summaryStatus, zeroSummary] = useReaderSummary((s) => [
    s.status,
    s.isZeroState,
  ])
  const goalOptIn = useReadingGoals((s) => s.goalOptIn)
  const { isAndroid, isPlusUser } = useStatsPermission()
  const hasSummary = summaryStatus === 'success'
  const showShareButton =
    isSelfView && !isAndroid && summaryStatus === 'success' && !zeroSummary
  const hideUpsell = !isSelfView || isPlusUser || isAndroid
  const theme = useStatsTheme((s) => s.theme)
  const isDarkTheme = theme.id.includes('dark')

  const showExtraModules = () => {
    return (
      <FlexBox
        className={css`
          padding-bottom: ${isDarkTheme ? 12 : 50}px;
          width: 100%;
          gap: 16px;
        `}
        flexDirection="column"
      >
        {!goalOptIn ? null : <ReadingGoals />}
        <MomBooks />
        {hideUpsell ? null : <StatsPlusUpsell />}
        <GoalHabits type="books_finished" />
        <GoalHabits type="active_days" />
        <GoalHabits type="pages_read" />
      </FlexBox>
    )
  }

  const getBottomSpacing = () => {
    if (hasSummary || summaryStatus === 'loading') return 40
    return 15
  }

  return (
    <>
      <FlexBox
        className={css`
          position: relative;
          padding: 68px 32px ${getBottomSpacing()}px;
          gap: 16px;
        `}
        flexDirection="column"
      >
        <FlexBox
          className={css`
            width: 100%;
            gap: 24px;
          `}
          flexDirection="column"
        >
          <ReaderSummary />
          {hasSummary ? <ReaderStatCards /> : null}
        </FlexBox>
        {showShareButton ? <ReaderSummaryScreenshotButton /> : null}
      </FlexBox>
      {showExtraModules()}
    </>
  )
}
